module.exports = __webpack_public_path__ + "media/icons/i-1-apps-e3c9a447.png";